import { fakerVI } from "@faker-js/faker";
import AxiosMockAdapter from "axios-mock-adapter";
import { REPORT_TYPE, TRANG_THAI } from "pages/bao-cao/constant";
import { v4 as uuidv4 } from "uuid";
import axiosInstance from "./axiosInstance";
import { loaiViPhams } from "pages/theo-doi-vi-pham/constant";

const mock = new AxiosMockAdapter(axiosInstance, { delayResponse: 100 });

function getRandomAvatarUrl(gender?: "male" | "female" | "lego"): string {
  const rand = Math.floor(Math.random() * 100); // từ 0 đến 99

  if (gender === "male") {
    return `https://randomuser.me/api/portraits/men/${rand}.jpg`;
  }

  if (gender === "female") {
    return `https://randomuser.me/api/portraits/women/${rand}.jpg`;
  }

  if (gender === "lego") {
    return `https://randomuser.me/api/portraits/lego/${rand % 10}.jpg`;
  }

  // Nếu không truyền, ngẫu nhiên nam/nữ
  const isMale = Math.random() < 0.5;
  return isMale
    ? `https://randomuser.me/api/portraits/men/${rand}.jpg`
    : `https://randomuser.me/api/portraits/women/${rand}.jpg`;
}

const quanLydoiTuongViPham = [...Array(10)].map((_, index) => ({
  id: index.toString(),
  image: getRandomAvatarUrl(),
  cccd: fakerVI.phone.number("####-####-#####"),
  soDienThoai: fakerVI.phone.number("####-####-#####"),
  hoVaTen: fakerVI.person.fullName(),
  ngaySinh: fakerVI.date.birthdate(),
  diaChi: fakerVI.location.streetAddress(),
  soLanViPham: Math.floor(Math.random() * 100),
  thoiGianTao: fakerVI.date.anytime(),
  ngayCapCCCD: fakerVI.date.anytime(),
  nguoiTao: fakerVI.person.fullName(),
  nguoiChinhSua: fakerVI.person.fullName(),
  gioiTinh: true,
  noiCapCCCD: "Cục Cảnh sát QLHC về TTXH",
  masterPhuongXaId: "96f8da1a-81cf-4e64-a6a3-0e13b6061571",
  masterPhuongXa: {
    ma: "05905",
    ten: "Phường Thuận Thành",
    capDonVi: "Phường",
    masterQuanHuyenId: "a4dbeff6-6581-44c6-b454-51b0fb8e34ec",
    id: "96f8da1a-81cf-4e64-a6a3-0e13b6061571",
    createdDate: "0001-01-01T00:00:00",
    updatedDate: "0001-01-01T00:00:00",
    createdBy: "00000000-0000-0000-0000-000000000000",
    updatedBy: "00000000-0000-0000-0000-000000000000",
  },
  masterQuanHuyenId: "a4dbeff6-6581-44c6-b454-51b0fb8e34ec",
  masterQuanHuyen: {
    ma: "172",
    ten: "Thành phố Phổ Yên",
    capDonVi: "Thành phố",
    masterTinhThanhPhoId: "b3095ba0-cf05-4628-a635-06418cf3457a",
    id: "a4dbeff6-6581-44c6-b454-51b0fb8e34ec",
    createdDate: "0001-01-01T00:00:00",
    updatedDate: "0001-01-01T00:00:00",
    createdBy: "00000000-0000-0000-0000-000000000000",
    updatedBy: "00000000-0000-0000-0000-000000000000",
  },
  masterTinhThanhPhoId: "b3095ba0-cf05-4628-a635-06418cf3457a",
  masterTinhThanhPho: {
    ma: "19",
    ten: "Tỉnh Thái Nguyên",
    capDonVi: "Tỉnh",
    id: "b3095ba0-cf05-4628-a635-06418cf3457a",
    createdDate: "0001-01-01T00:00:00",
    updatedDate: "0001-01-01T00:00:00",
    createdBy: "00000000-0000-0000-0000-000000000000",
    updatedBy: "00000000-0000-0000-0000-000000000000",
  },
}));

const hoSoViPhamList = [...Array(10)].map((_, index) => ({
  id: index.toString(),
  cccd: loaiViPhams[Math.floor(fakerVI.internet.httpStatusCode() / 100)]?.text,
  hoVaTen: fakerVI.person.fullName(),
  ngaySinh: fakerVI.date.birthdate(),
  diaChi: fakerVI.location.streetAddress(),
  thoiGianTao: fakerVI.date.anytime(),
  nguoiTao: fakerVI.person.fullName(),
  nguoiChinhSua: fakerVI.person.fullName(),
  moTaViPham: fakerVI.lorem.sentences(2),
  trangThai: fakerVI.helpers.arrayElement([0, 1]),
  soTienPhat: parseFloat(fakerVI.finance.amount(100000, 5000000, 0)),
  soQuyetDinhXuPhat: fakerVI.string.alphanumeric(10).toUpperCase(),
  ngayQuyetDinh: fakerVI.date.recent().toISOString().split("T")[0],
  ngayLapHoSo: fakerVI.date.anytime(),
}));

const theoDoiViPhamList = [...Array(10)].map((_, index) => ({
  id: index.toString(),
  cccd: loaiViPhams[Math.floor(fakerVI.internet.httpStatusCode() / 100)]?.text,
  hoVaTen: fakerVI.person.fullName(),
  ngaySinh: fakerVI.date.birthdate(),
  trangThai: fakerVI.helpers.arrayElement([0, 1]),
  thoiGianTao: fakerVI.date.anytime(),
  nguoiTao: fakerVI.person.fullName(),
  nguoiChinhSua: fakerVI.person.fullName(),
}));

const baoCaoList = [...Array(10)].map((_, index) => ({
  id: index.toString(),
  tenBaoCao: `Báo cáo ${Math.floor(Math.random() * 10)}`,
  tenMauBaoCao:
    REPORT_TYPE[Math.floor(fakerVI.internet.httpStatusCode() / 100)]?.text ||
    REPORT_TYPE[0].text,
  mauSoBaoCao: Math.floor(Math.random() * 10),
  fromDate: fakerVI.date.past(),
  toDate: fakerVI.date.future(),
  status: TRANG_THAI.DA_TAO,
}));

// GET /api/bao-cao -> trả danh sách
mock.onPost("/api/BaoCao/search").reply(200, {
  data: baoCaoList,
  total: baoCaoList.length,
  page: 1,
  pageSize: 10,
});

// GET /api/bao-cao/:id -> trả chi tiết
mock.onGet(/\/api\/BaoCao\/[^/]+/).reply((config) => {
  const id = config.url?.split("/").pop();
  const data = baoCaoList.find((item) => item.id === id);

  if (data) {
    return [200, { data }];
  } else {
    return [404, { message: "Không tìm thấy" }];
  }
});

mock.onPost("/api/TheoDoiViPham/search").reply(200, {
  data: theoDoiViPhamList,
  total: theoDoiViPhamList.length,
  page: 1,
  pageSize: 10,
});

mock.onGet(/\/api\/TheoDoiViPham\/[^/]+/).reply((config) => {
  const id = config.url?.split("/").pop();
  const data = theoDoiViPhamList.find((item) => item.id === id);

  if (data) {
    return [200, { data }];
  } else {
    return [404, { message: "Không tìm thấy" }];
  }
});

mock.onPost("/api/HoSoViPham/search").reply(200, {
  data: hoSoViPhamList,
  total: hoSoViPhamList.length,
  page: 1,
  pageSize: 10,
});

mock.onGet(/\/api\/HoSoViPham\/[^/]+/).reply((config) => {
  const id = config.url?.split("/").pop();
  const data = hoSoViPhamList.find((item) => item.id === id);

  if (data) {
    return [200, { data }];
  } else {
    return [404, { message: "Không tìm thấy" }];
  }
});

mock.onPost("/api/DoiTuongViPham/search").reply(200, {
  data: quanLydoiTuongViPham,
  total: quanLydoiTuongViPham.length,
  page: 1,
  pageSize: 10,
});

mock.onGet(/\/api\/DoiTuongViPham\/[^/]+/).reply((config) => {
  const id = config.url?.split("/").pop();
  const data = quanLydoiTuongViPham.find((item) => item.id === id);

  if (data) {
    return [200, { data }];
  } else {
    return [404, { message: "Không tìm thấy" }];
  }
});

export function generateMockPermissions() {
  const permissionNames = [
    "Xem người dùng",
    "Thêm người dùng",
    "Sửa người dùng",
    "Xoá người dùng",
    "Xem báo cáo",
    "Xuất báo cáo",
    "Quản lý phân quyền",
    "Truy cập hệ thống",
    "Cấu hình hệ thống",
    "Xem nhật ký hoạt động",
  ];

  return {
    data: permissionNames.map((name) => ({
      id: fakerVI.string.uuid(),
      displayName: name,
    })),
  };
}

mock.onGet("/master/permission").reply(200, generateMockPermissions());

mock.onAny().passThrough();

export default mock;
